export default "__VITE_ASSET__It043WdZ__"